import * as React from 'react';
import { connect } from 'react-redux';
import {GET_PORTABLE_POSSESSIONS_INSURANCE, ADD_REPLACEMENT_VALUE, BANKING_DETAILS } from '../../../routes/routes';
import { ProgressBar, Button } from 'react-bootstrap';
import { navigateTo } from '../../../actions/navigationActions';
import { addReplacementValue } from '../../../actions/salesActions';
import PortablePossessionsTile from './PortablePossessionsTile';
import './AddPortablePossessions.css';
import { postToController } from '../../../actions/apiActions';

class AddPortablePossessions extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            hasSubmitted: false,
            loggedIn: this.props.auth.uid ? true : false,
            tileData: [],
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleBack(e: any) {
        if (this.props.cart.products.length > 0) {
            this.props.redirectTo(BANKING_DETAILS)
        } else if (this.props.profile.policyId !== "") {
            this.props.redirectTo(GET_PORTABLE_POSSESSIONS_INSURANCE)
        }
    }

    async handleNext() {
        await this.setState({ hasSubmitted: true });
        await this.props.redirectTo(ADD_REPLACEMENT_VALUE)
    }

    async componentDidMount() {
        await postToController(this.props.dispatch, 'GetMobilePortablePossessions', JSON.stringify({})).then(async (response) => {
            await this.setState({ tileData: response.portables });
        })
    }

    public render() {
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-05 logged-out"}>
                <div className="ssp-preload">
                    <img src="/my-policy/Images/OnlineQuotation/crown-icon.png" alt="" title="" />
                    <img src="/my-policy/Images/OnlineQuotation/crown-icon-56px.png" alt="" title="" />
                    <img src="/my-policy/Images/add-cover-nugreen-46px-46px.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-watch.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-bicycle.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-cellphone.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-firearm.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-jewellery.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-musical-equipment.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-laptop.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-clothing.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-camera-equipment.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-sports-equipment.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-tablet.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-golf-cart.svg" alt="" title="" />
                    <img src="/my-policy/Images/PortablePossessions/icon-personal-insurance-glasses.svg" alt="" title="" />
                </div>
                <div className="col-12 text-lg-center text-md-center ssp-add-portable-possessions">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <Button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></Button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <Button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></Button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={35} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container ssp-addportablepossesions-main-contentholder mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col nopa text-center">
                                <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                    <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                </div>
                                <div className="mt-21px mobile-mt-17px mb-28px mobile-mb-30px text-center ssp-addportable-possessions-p-holder">
                                    <div className="mb-6px font-size-16px font-weight-bold ssp-addportable-possessions-intro-header">
                                        Add portable possession
                                    </div>
                                    <div className="font-size-16px ssp-addportable-possessions-intro-text ">
                                        Please select the type of portable&nbsp;
                                        <br className="mobile-br" />
                                        possession you'd like to cover
                                    </div>
                                </div>
                                {this.state.tileData.length > 0 &&

                                    <div className="row noma ssp-addportable-possessions-tile-holder-row pb-5">
                                        {this.state.tileData.map((item, index) =>
                                            <div className="nopa ssp-portable-possessions-tile-outer" key={index + 1}>
                                                < PortablePossessionsTile title={item.name} icon={item.icon} portableId={item.portableType} />
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        cart: state.cart,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchAddReplacementValue: () => dispatch(addReplacementValue()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddPortablePossessions);